import React from "react";

// onChange={props.onChange}
export const SearchBoxSelect = props => <select id={props.id} value={props.selected} onChange={props.onChange} >
  {(() => {
    if (props.empty_option) {
      if ([undefined, ''].includes(props.value)) return <option value="" selected></option>
      else return <option value=""></option>
    }
  })()}
  {props.options.map((option) => {
    if (option.value == props.selected) {
      return <option value={option.value} selected>{option.label}</option>
    }
    else {
      return <option value={option.value}>{option.label}</option>
    }
  }
  )}
</select>
